// enumerates the compass directions
export var Direction;
(function (Direction) {
    Direction[Direction["None"] = 0] = "None";
    Direction[Direction["North"] = 1] = "North";
    Direction[Direction["East"] = 2] = "East";
    Direction[Direction["South"] = 4] = "South";
    Direction[Direction["West"] = 8] = "West";
})(Direction || (Direction = {}));
//# sourceMappingURL=direction.js.map